import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { CreditCard } from "lucide-react";

const money = (v) => `£${(v ?? 0).toFixed(2)}`;

export const CardEconomicsCard = () => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get("/admin/card-economics")
      .then((r) => setD(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || e.message));
  }, []);

  if (err) return null;
  if (!d) return <div className="pg-card p-5 text-[#9CA8B8] pg-mono text-xs">Loading card economics…</div>;

  const rows = [
    { label: `GlobalPay fee (${d.fee_pct}%)`, value: `−${money(d.fee_total)}`, cls: "text-[#FF8A5B]" },
    { label: `Reserve held (${d.reserve_pct}% · rolling ${d.reserve_days}d)`, value: `−${money(d.reserve_held)}`, cls: "text-[#FFD166]" },
    { label: "Reserve released back", value: `+${money(d.reserve_released)}`, cls: "text-[#5EEAD4]" },
    { label: `Awaiting payout (T+${d.payout_days})`, value: money(d.awaiting_payout), cls: "text-[#9CA8B8]" },
  ];

  return (
    <div className="pg-card p-5" data-testid="card-economics-card">
      <div className="pg-micro mb-3 flex items-center gap-2 text-[#5EEAD4]">
        <CreditCard size={11} /> Card Economics · GlobalPay
      </div>
      <div className="flex items-baseline justify-between mb-1">
        <span className="text-[#9CA8B8] text-xs">Card sales ({d.card_orders} orders)</span>
        <span className="text-[#F7FAFC] text-lg font-bold pg-mono" data-testid="card-gross">{money(d.card_gross)}</span>
      </div>
      {rows.map((r) => (
        <div key={r.label} className="flex items-baseline justify-between py-0.5">
          <span className="text-[#9CA8B8] text-xs">{r.label}</span>
          <span className={`text-sm pg-mono ${r.cls}`}>{r.value}</span>
        </div>
      ))}
      <div className="border-t border-[#1E2E44] mt-2 pt-2 flex items-baseline justify-between">
        <span className="text-[#F7FAFC] text-xs font-semibold">Net received to date</span>
        <span className="text-[#A6FF00] text-lg font-bold pg-mono" data-testid="card-net-received">{money(d.net_received_to_date)}</span>
      </div>
      <div className="flex items-baseline justify-between">
        <span className="text-[#9CA8B8] text-[10px]">After full reserve release</span>
        <span className="text-[#9CA8B8] text-xs pg-mono">{money(d.net_after_full_release)}</span>
      </div>
    </div>
  );
};

export default CardEconomicsCard;
